export default "__VITE_ASSET__D9qYc3Xj__"